module.exports = __webpack_public_path__ + "img/consOne.f133e1b2.svg";